import React, { useEffect } from "react";

import "./reconnect-modal.styles.css";
import { useSelector } from "react-redux";
import MicroModal from "micromodal";
import LinearIndeterminate from "../LinearProgress";

const ReconnectModal = () => {
  const isReconnectModalActive = useSelector(
    (state) => state.isReconnectModalActive
  );

  useEffect(() => {
    MicroModal.init({
      openTrigger: "none", // não permite que botões abram o modal
      closeTrigger: "none", // desativa botões com data-micromodal-close
      disableScroll: true,
      awaitCloseAnimation: true,
      disableFocus: true, // impede o foco automático
      onClose: () => {}, // ignora chamadas automáticas de onClose
    });

    if (isReconnectModalActive) {
      MicroModal.show("modal-reconnect");
    } else {
      MicroModal.show("modal-reconnect");
      MicroModal.close("modal-reconnect");
    }
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && isReconnectModalActive) {
        event.stopPropagation();
        event.preventDefault();
      }
    };

    // Adiciona o listener
    document.addEventListener("keydown", handleKeyDown, true);

    return () => {
      document.removeEventListener("keydown", handleKeyDown, true);
    };
  }, [isReconnectModalActive]);

  return (
    <div
      className="reconnect-modal micromodal-slide"
      id="modal-reconnect"
      aria-hidden="true"
    >
      <div className="modal__overlay" tabIndex="-1">
        <div className="modal__container">
          <div className="modal__content">
            {/* <header className="reconnect-modal__header">
              <h2>Reconectando...</h2>
            </header> */}
            <div className="reconnect-modal__content">
              <div className="reconnect-modal__content__icon">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="7" fill="#fff3e0" />

                  <path d="M12,7 L16.5,16 L7.5,16 Z" fill="#ff9800" />

                  <rect
                    x="11.5"
                    y="9"
                    width="1"
                    height="3.5"
                    rx="0.5"
                    fill="white"
                  />
                  <circle cx="12" cy="14" r="0.6" fill="white" />

                  <circle
                    cx="12"
                    cy="12"
                    r="7"
                    fill="none"
                    stroke="#ff980050"
                    stroke-width="0.5"
                  >
                    <animate
                      attributeName="r"
                      values="7;9;7"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <animate
                      attributeName="opacity"
                      values="0.7;0;0.7"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                  </circle>
                </svg>
              </div>
              <h2 className="reconnect-modal__content__title">
                Reconectando...
              </h2>
              <p className="reconnect-modal__content__text">
                Estamos tentando restabelecer a conexão com o sistema. Por
                favor, aguarde alguns instantes.
              </p>
              <div className="reconnect-modal__content__progress-loading">
                <LinearIndeterminate />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReconnectModal;
